import axios from 'axios'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  // Never leave a Vault page in a permanent skeleton state when the staging
  // API accepts a connection but a dependency stalls. React Query can retry
  // bounded transient failures and then present the normal error state.
  timeout: 10_000,
  withCredentials: false,
})

export { http }
